import Axios from 'axios'

const patient = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  createPatient (item) {
    return this.axios().post('/patient', item)
  },
  editPatient (item) {
    return this.axios().put('/patient', item)
  },
  deletePatient (id) {
    return this.axios().delete('/patient/' + id)
  },
  deletePatientDoctor (id) {
    return this.axios().delete('/patient/doctor/' + id)
  },
  getPatients () {
    return this.axios().get('/patient')
  },
  getPatientById (id) {
    return this.axios().get('/patient/' + id)
  }
}

export default patient
